// TODO: delete when new customize UI enabled for everyone
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b_ from 'b_';
import Button from '../Button';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import ConsoleModal from '../ConsoleModal/ConsoleModal';
import { FTHeading } from '../Fuse';
import { ObservableToggle } from '../Toggle/Toggle';
import { ConsoleCard, ConsoleField } from '../ConsoleFragments';
import FuseTextfield from '../FuseControls/FuseTextfield';
import EditCustomPageContent from '../ConsoleCustomPages/EditCustomPageContent';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import PagePreview from '../PagePreview/PagePreview';
import PasswordlessAuthStore from '../../stores/PasswordlessAuthStore';
import AsyncActionStore from '../../stores/AsyncActionStore';
import CustomPagesStore from '../../stores/CustomPagesStore';
import SnackStore from '../../stores/SnackStore';
import BrowserLogin from '../Authentication/BrowserLogin';
import FlagStore from '../../stores/FlagStore';
import './RegistrationNoticeEditModal.css';

const block = b_.lock('RegistrationNoticeEditModal');

export const createPropsForRegistrationNoticePreview = (store) => ({
    passwordlessAuth: new PasswordlessAuthStore({
        submitEmailState: AsyncActionStore.resolved({
            type: 'registrationNotice',
            content: store.getContent(),
        }),
        flipNextStore: new FlagStore(true),
        acceptPrivacyPolicy: () => {},
        startAgain: () => {},
    }),
});

export const registerNoticeTooltipInfo = 'Display a notice during the registration' +
    ' process that requires the user to accept the terms before' +
    ' proceeding to register. links to your organization’s documents can be included in the message.';

class RegistrationNoticeEditModal extends Component {
    static propTypes = {
        customPages: CustomPagesStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    onCloseClick = () => {
        this.props.customPages.registrationNotice.isModalOpen.close();
        this.props.customPages.registrationNotice.clean();
    };

    onSave = () => {
        this.props.customPages.save(this.props.customPages.registrationNotice).then(() => {
            this.props.snack.showSuccess('Registration Notice has been saved.');
        }).catch((e) => {
            this.props.snack.showError(`Failed to save registration notice. ${e.message}`);
        }).finally(() => {
            this.props.customPages.registrationNotice.isModalOpen.setFalse();
        });
    }

    render() {
        const { registrationNotice } = this.props.customPages;
        return <ConsoleModal
            isOpen={registrationNotice.isModalOpen.isOpen}
            onClose={registrationNotice.existEditMode}
            title={'Edit Registration Notice'}
            className={block('Modal')}
            style={{ content: { width: '100%' } }}
            contentClassName={block('ModalContent')}
            headerActions={<Button
                primaryGreen
                raised
                onClick={this.onSave}
                loading={registrationNotice.saveStatus.isLoading}
                disabled={!registrationNotice.hasChanged() || !registrationNotice.isValid()}
            >{'SAVE'}</Button>}
        >
            <ConsoleCard className={block('Section')}>
                <FTHeading style={{ marginBottom: 20 }}>Registration Notice</FTHeading>
                <ConsoleField
                    titleClassName={block('Title')}
                    name="Registration Notice Status"
                    info={registerNoticeTooltipInfo}
                    infoPosition="bottom"
                >
                    <ObservableToggle
                        className={block('Toggle')}
                        onLabel={'ENABLED'}
                        offLabel={'DISABLED'}
                        store={registrationNotice.enabledStore}
                    />
                </ConsoleField>
                {registrationNotice.enabledStore.value ? <Fragment>
                    <FuseTextfield
                        className={block('Headline')}
                        store={registrationNotice.headlineStore}
                        label="Title"
                    />
                    <EditCustomPageContent
                        store={registrationNotice.editCustomPageContent}
                    />
                    <FuseConsoleCardFooter text={'Text will not be translated to other languages.'} />
                </Fragment> : null }
            </ConsoleCard>
            {registrationNotice.enabledStore.value ? <ConsoleCard className={block('Section')}>
                <FTHeading style={{ marginBottom: 20 }}>Preview</FTHeading>
                <PagePreview
                    pageComponent={BrowserLogin}
                    previewToggle={registrationNotice.previewToggleInEditMode}
                    headline="Registration Notice"
                    pageProps={createPropsForRegistrationNoticePreview(registrationNotice)}
                />
            </ConsoleCard> : null }

            <FuseConfirmationModal
                store={registrationNotice.exitConfirmationModal}
                onConfirm={this.onCloseClick}
            />
        </ConsoleModal>;
    }
}

export default inject('customPages', 'snack')(observer(RegistrationNoticeEditModal));

